import {
  Dialog,
  DialogTitle,
  DialogContent,
  CircularProgress,
  DialogActions,
  Button,
} from '@mui/material';
import React from 'react';
import {useSnackbar} from 'notistack';
import {useAddCompanyMemberMutation, useGetCompaniesQuery, useGetRolesQuery} from 'api';
import MemberForm from './MemberForm';

function CreateMemberModal({open, onClose}) {
  const {data, isLoading, isError} = useGetCompaniesQuery();
  const {data: roles} = useGetRolesQuery();

  const formRef = React.useRef();
  const [addMember] = useAddCompanyMemberMutation();
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  const {enqueueSnackbar} = useSnackbar();
  return (
    <Dialog fullWidth scroll="body" maxWidth="sm" open={open} onClose={onClose}>
      <DialogTitle mb={2} variant="h6">
        Create Member
      </DialogTitle>
      <DialogContent>
        <MemberForm
          disabled={isLoading || isError}
          companiesList={data || []}
          roles={roles || []}
          ref={formRef}
          onSubmit={async (values, actions) => {
            try {
              setIsSubmitting(true);

              const newObj = {
                ...values,
              };
              await addMember(newObj).unwrap();
              actions.resetForm();
              enqueueSnackbar('Member created successfully', {
                variant: 'success',
              });
              onClose();
            } catch (e) {
              const message =
                e.status === 400 ? e.memberResponse?.details?.[0]?.message : undefined;
              enqueueSnackbar(message || 'Failed to create member', {
                variant: 'error',
              });
            } finally {
              setIsSubmitting(false);
            }
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button disabled={isSubmitting} color="inherit" variant="outlined" onClick={onClose}>
          Cancel
        </Button>
        <Button
          endIcon={isSubmitting ? <CircularProgress ml={2} size={16} /> : null}
          disabled={isSubmitting}
          color="primary"
          variant="contained"
          onClick={() => formRef.current?.submit?.()}
        >
          Create
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default CreateMemberModal;
